import { combineReducers } from 'redux'
import DashboardLoader from '../dashboard/loader'
import ErrorLoader from '../errors/loader'
import EventLoader from '../monitor/events/loader'
import MonitorLoader from '../monitor/loader'
import SnapshotLoader from '../monitor/snapshot/loader'
import OperationLoader from '../operation/loader'
import ProfileListLoader from '../profile-list/loader'
import { v2Reducer } from '../redux/V2/v2Reducer'
import TraceLoader from '../trace/loader'
import { tidewaysContextReducer } from './contextReducer'

export default combineReducers({
    tidewaysContext: tidewaysContextReducer,
    operations: OperationLoader.handleAction,
    traces: TraceLoader.handleAction,
    snapshots: SnapshotLoader.handleAction,
    events: EventLoader.handleAction,
    monitor: MonitorLoader.handleAction,
    profiles: ProfileListLoader.handleAction,
    dashboard: DashboardLoader.handleAction,
    errors: ErrorLoader.handleAction,
    v2: v2Reducer,
})
